import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Login from "./Container/Login";
import "react-toastify/dist/ReactToastify.css";
import "./Styles/sb-admin-2.css";
import "./Styles/style.css";
import "./Styles/responsive.css";
import PrivateRoute from "./Auth";
import Dashboard from "./Container/Dashboard";
import Admin from "./Container/Admin";
import Users from "./Container/Users";
import UserDetail from "./Container/Users/userDetail";
import PostDetails from "./Container/PostDetails";
import Report from "./Container/Report";
import SessionDetails from "./Container/SessionDetails";
import RescheduleMaster from "./Container/RescheduleMaster";
import CancellationMaster from "./Container/CancellationMaster";
import Feedback from "./Container/Feedback";
import AppSettings from "./Container/AppSettings";
import RefundSettings from "./Container/RefundSettings";
import Categories from "./Container/Categories";
import Coupons from "./Container/Coupons";
import Payments from "./Container/Payments";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route exact path="/login" element={<Login />} />
        <Route element={<PrivateRoute />}>
          <Route exact path="/" element={<Dashboard />} />
          <Route exact path="/admin" element={<Admin />} />
          <Route exact path="/users" element={<Users />} />
          <Route exact path="/categories" element={<Categories />} />
          <Route exact path="/coupons" element={<Coupons />} />
          <Route exact path="/users/:id" element={<UserDetail />} />
          <Route exact path="/post-details" element={<PostDetails />} />
          <Route exact path="/report" element={<Report />} />
          <Route exact path="/session-details" element={<SessionDetails />} />
          <Route
            exact
            path="/reschedule-master"
            element={<RescheduleMaster />}
          />
          <Route
            exact
            path="/cancellation-master"
            element={<CancellationMaster />}
          />
          <Route exact path="/feedback" element={<Feedback />} />
          <Route exact path="/app-settings" element={<AppSettings />} />
          <Route exact path="/refund-settings" element={<RefundSettings />} />
          <Route exact path="/payments" element={<Payments />} />
        </Route>
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Router>
  );
};

export default App;
